








































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import pxButton from '@/dex-shared/components/px-button.vue';
import SubjectModel from '@/models/SubjectModel';

export default Vue.extend({
  components: {
    pxButton,
  },
  props: {
    entityName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      highlightedSubjects: 'highlightedSubjects',
    }),
    weeklySubject(): SubjectModel {
      return this.highlightedSubjects[0];
    },
    mainTitle(): string {
      switch (this.entityName) {
        case 'correction':
          return 'Suas correções aparecerão aqui';
        case 'draft':
          return 'Seus rascunhos aparecerão aqui';
      }
      return '';
    },
    subtitle(): string {
      switch (this.entityName) {
        case 'correction':
          return 'Você ainda não tem nenhuma correção. Que tal começar escrevendo sobre o Tema da Semana?';
        case 'draft':
          return 'Você ainda não tem rascunhos. Que tal começar escrevendo sobre o Tema da Semana?';
      }
      return '';
    },
  },
  created() {
    this.$store.dispatch('PULL_HIGHLIGHTED_SUBJECTS', {
      page: 1,
      items: 12,
    });
  },
});
